import { useMemo } from 'react';
import { useGetAiAgentModelList } from '../../../../../../shared/apis/ai-agent/model/reactQueries';

export interface IModelOption {
  value: string;
  label: string;
}

interface IUseModelOptions {
  includeAll?: boolean;
}

export function useModelOptions(companyId: number, options: IUseModelOptions = {}) {
  const { includeAll = true } = options;
  const { data: modelData } = useGetAiAgentModelList({
    companyId,
    page: 1,
    size: 10000,
  });

  const modelOptions = useMemo(
    () => [
      ...(includeAll ? [{ value: 'all', label: '전체' }] : []),
      ...(modelData?.result.map((model) => ({
        value: model.modelId.toString(),
        label: `${model.assignedName} (${model.model})`,
      })) || []),
    ],
    [includeAll, modelData?.result],
  );

  return modelOptions;
}
